import CertifyBeneficialOwnershipModal from "./CertifyBeneficialOwnershipModal"

export default CertifyBeneficialOwnershipModal
